import { getAllOrderShowtimesInJourney, getJourneyState, getOrderRelatedShowtimeById, isNonEmptyArray } from '@vista/omnichannel-components-domain';
export function getFeaturedShowtimeForJourney(journey) {
    const { nextOrderShowtime } = getJourneyState(journey);
    if (nextOrderShowtime)
        return getOrderRelatedShowtimeById(nextOrderShowtime.showtimeId);
    const orderShowtimes = getAllOrderShowtimesInJourney(journey);
    return isNonEmptyArray(orderShowtimes) ? getOrderRelatedShowtimeById(orderShowtimes[0].showtimeId) : undefined;
}
